<template>
  <el-container>
    <el-header>
      <NavMenu></NavMenu>
    </el-header>
    <el-main>
      <AppIndex1></AppIndex1>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>

<script>
import NavMenu from "../common/NavMenu";
import AppIndex1 from "./AppIndex1";
import Footer from "../common/Footer";
export default {
  name: "AppIndex",
  components: {
    NavMenu,
    AppIndex1,
    Footer,
  },
};
</script>

<style lang="less" scoped>
/deep/.el-main {
  overflow: hidden !important;
}
</style>


// WEBPACK FOOTER //
// src/components/home/AppIndex.vue